<!--
 * @Author: cryi.liu
 * @Date: 2020-06-17 11:36:01
 * @LastEditTime: 2020-06-18 14:31:29
 * @Description: 阅卷表格
-->
<template>
  <i-table class="mark-table" border :columns="columns" :data="data" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from '../../../../../utils';

export default {
  name: 'MarkTable',
  props: {
    questionIndex: { type: Number, required: true },
    data: { type: Array, required: true },
  },
  data() {
    return {
      columns: [],
    };
  },
  computed: {
    ...mapGetters({
      questionList: 'answerMarkStore/questionList',
      markUserAtQuestion: 'answerMarkStore/markUserAtQuestion',
    }),
    score() {
      return this.questionList[this.questionIndex].totalScore;
    },
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.setColumns();
      },
    },
  },
  methods: {
    ...mapActions({
      setMarkUserAtQuestion: 'answerMarkStore/invokeSetMarkUserAtQuestion',
    }),
    /**
     * 设置表格列
     */
    setColumns() {
      this.columns = [
        {
          title: '考试人',
          align: 'center',
          maxWidth: 120,
          key: 'userName',
        },
        {
          title: '答案（匿名阅卷）',
          align: 'center',
          key: 'answer',
        },
        {
          title: '分数',
          align: 'center',
          maxWidth: 100,
          render: (h, { row }) => h('i-input-number', {
            props: {
              size: 'small',
              min: 0,
              max: this.score,
              value: row.userScore ? row.userScore : null,
            },
            style: {
              width: '52px',
            },
            on: {
              'on-change': this.userAnswerScoreChangeHandler(row),
            },
          }),
        },
      ];
    },
    /**
     * 设置学员阅卷分数
     */
    userAnswerScoreChangeHandler(row) {
      const self = this;
      // eslint-disable-next-line prefer-arrow-callback
      return debounce(function (value) {
        const markUserAtQuestion = JSON.parse(JSON.stringify(self.markUserAtQuestion));

        markUserAtQuestion[row.id] = value;

        self.setMarkUserAtQuestion({ markUserAtQuestion });
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
.mark-table {
  width: 100%;

  /deep/ .ivu-input {
    &:focus {
      border-color: #dcdee2;
      box-shadow: none;
    }

    &:hover {
      border-color: #dcdee2;
    }
  }
}
</style>
